import { HTMLProps, useEffect } from "react";
import useAutosizeTextArea from "src/hooks/useAutosizeTextArea";

const VARIANTS = {
	large: "input-editable-title input-editable-title_large",
	medium: "input-editable-title input-editable-title_medium",
};

export type EditableVariant = keyof typeof VARIANTS;

interface EditableTextProps extends HTMLProps<HTMLTextAreaElement> {
	variant: EditableVariant;
}

const EditableText = ({
	variant,
	size,
	autoFocus,
	...rest
}: EditableTextProps) => {
	const { ref } = useAutosizeTextArea();

	useEffect(() => {
		if (ref?.current && autoFocus) {
			ref.current.focus();
			ref.current.selectionStart = ref.current.value.length;
		}
		setTimeout(() => {
			if (ref?.current) {
				ref.current.style.height = "0px";
				const scrollHeight = ref.current.scrollHeight;
				ref.current.style.height = scrollHeight + "px";
			}
		}, 300);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<textarea
			{...{ ref, ...rest }}
			autoFocus={false}
			className={`${VARIANTS[variant]} w-full ${rest?.className || ""}`}
		/>
	);
};

export default EditableText;
